module.exports = __webpack_public_path__ + "static/img/empty.3595acf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/empty.png
// module id = HeD3
// module chunks = 29